module.exports = __webpack_public_path__ + "static/media/k9.765b020d.jpg";